import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { Typography } from '@tkww/the-bash-frontend';

const BookingBenefitCard = ({ title, description, icon, iconBackgroundColor }) => (
  <Box
    position="relative"
    padding={3}
    textAlign="left"
    sx={(theme) => ({
      backgroundColor: theme.palette.background.default,
      width: { xs: '100%', xl: 540 },
      border: `1px solid ${theme.palette.grey[400]}`,
      borderRadius: '6px',
    })}
  >
    <Typography variant="h3" mt={0} mb={{ xs: 3, md: 2 }} maxWidth={{ xs: '50%' }}>
      {title}
    </Typography>
    <Typography variant="body1" mb={0} width={{ xs: '100%', md: 433 }}>
      {description}
    </Typography>
    <Box
      position="absolute"
      top={0}
      right={0}
      backgroundColor={iconBackgroundColor}
      width={93}
      height={93}
      textAlign="right"
      sx={{
        borderTopRightRadius: 6,
        clipPath:
          "path('M0.000976562 0H99.9996C103.313 0 106 2.68629 106 6V91.0219C101.593 91.6663 97.0852 92 92.4997 92C41.5801 92 0.270145 50.8563 0.000976562 0Z')",
      }}
    >
      <img width={64} height={64} src={icon} alt={`${title} icon`} />
    </Box>
  </Box>
);

BookingBenefitCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  icon: PropTypes.string.isRequired,
  iconBackgroundColor: PropTypes.string.isRequired,
};

export default BookingBenefitCard;
